<template>
  <div id="ordering-view">
    <div v-if="!gettingReportTemplateCompleted" class="create-ordering-report">
      <h2>Generate ordering report</h2>
      <div class="order-report-inputs">
        <div class="order-period-month">
          <h3>Select Order Period</h3>
          <div>
            <p>From:</p>
            <month-picker :no-default="true" @change="setDate"></month-picker>
          </div>
          <div class="months-input-container">
            <p>Months (count):</p>
            <v-text-field
              v-model="selectedOrderPeriodMonths"
              :type="'number'"
              id="order-period-input"
              outlined
              dense
              hide-details
            ></v-text-field>
          </div>
        </div>
        <v-divider class="mt-4 mb-8 grey lighten-1"></v-divider>
        <div class="supplier">
          <h3>Select Supplier</h3>
          <v-select
            :items="availableSuppliers"
            label="Supplier"
            v-model="selectedSupplier"
            dense
            outlined
            hide-details
          ></v-select>
        </div>
      </div>
      <div class="report-creation-controls">
        <div v-if="!gettingReportTemplate">
          <v-btn
            id="create-report-btn" 
            color="primary"
            large
            @click="createReport()"
            :disabled="!selectedSupplier || !selectedOrderPeriodMonths || !date.month"
          >
            Create report
          </v-btn>
        </div>
        <div v-if="gettingReportTemplate" class="create-report-msg create-report-msg-in-progress">
          <span>Creating report..</span>
        </div>
        <div v-if="gettingReportTemplateError" class="create-report-msg error-msg">
          <span>Error creating report</span>
        </div>
      </div>
    </div>

    <div v-if="gettingReportTemplateCompleted">
      <ordering-table :isInWindowPortal="false" />

      <div id="ordering-table-window-portal-container" v-if="orderingReportTableWindowOpen">
        <WindowPortal title="Ordering Report" :open="orderingReportTableWindowOpen">
          <ordering-table :isInWindowPortal="true" />
        </WindowPortal>
      </div>

    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { MonthPicker } from 'vue-month-picker'

import WindowPortal from '../components/WindowPortal';
import OrderingTable from '../components/OrderingTable';

export default {
  components: {
    MonthPicker,
    WindowPortal,
    OrderingTable,
  },
  data() {
    return {
      selectedSupplier: null,
      selectedOrderPeriodMonths: null,
      date: {
        from: null,
        to: null,
        month: null,
        year: null
      },
    }
  },
  computed: {
    ...mapState('ordering', [
      'availableSuppliers',
      'reportTemplate',
      'gettingReportTemplate',
      'gettingReportTemplateCompleted',
      'gettingReportTemplateError',
      'orderingReportTableWindowOpen'
    ]),
  },
  created() {
    this.$store.dispatch('ordering/getAvailableSuppliers');
  },
  methods: {
    setDate(date) {
      this.date = date;
    },
    createReport() {
      this.$store.dispatch('ordering/getReportTemplate', {supplier: this.selectedSupplier, year: this.date.year, month: this.date.monthIndex, orderPeriod: this.selectedOrderPeriodMonths});
    }
  }
};
</script>


<style>

.error-msg {
  color: #cf0436;
  font-size: 14pt;
}

.report-creation-controls {
  margin-top: 55px;
}

#report-page-link {
  margin-top: 0;
}

/*
.order-period-month {
  margin-bottom: 35px;
}

.report-supplier {
  margin-bottom: 30px;
}
*/

.report-supplier h3 {
  line-height: 1;
}

.months-input-container {
  margin-top: 25px;
}

.months-input-container .v-input {
  width: 120px;
}

.supplier .v-input {
  width: 400px;
}

#ordering-view h1 {
  margin-bottom: 30px;
}

#ordering-view .create-ordering-report {
  width: min-content;
}


</style>




// WEBPACK FOOTER //
// src/views/Ordering.vue